export default __webpack_public_path__ + "static/media/circle-of-life.c6d73b37.gif";